window.Yext = window.Yext || {};
import 'babel-polyfill';
import 'script-loader!node_modules/jquery/dist/jquery.min.js';

// uncomment if you need to do expand/collapse:
// import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/collapse.js';
// import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/transition.js';

import { Global } from 'js/common/global.js';
import { OnReady } from 'js/components/Util/Browser.js';
import { InitSoy2JS } from 'js/components/Soy2js/Soy2js.js';
InitSoy2JS(window.Yext);

import { DistanceCalculator } from 'ts/components/DistanceCalculator/index.ts';
import { Sniffer } from 'ts/components/Sniffer/index.ts';

import { Description } from 'js/components/Description/index.js';
import { GoogleAnalytics } from 'js/components/GoogleAnalytics/index.js';
import { Image } from 'js/components/Image/index.js';
import { LocationHours } from 'js/components/LocationHours/index-override.js';
import { Maps } from 'js/components/Maps/index.js';

import { SearchMap } from 'js/search/modules/Google.js';
import { Daypart } from 'js/common/modules/Daypart.js';
import { CurrentlyOperatingServices } from 'js/common/modules/CurrentlyOperatingServices.js';
import { Product } from 'js/common/modules/Product.js';
import { LocationList } from 'js/common/modules/LocationList.js';
import { JobCarousel } from 'js/common/modules/JobCarousel';

Yext.Maps = Maps;
Yext.Maps.SearchMap = SearchMap;

Global.init();
GoogleAnalytics.enableAutotracking('yext');

OnReady(() => {
  Daypart.loadAndRun();
  Maps.loadAndRun();
  LocationHours.loadAndRun();
  new Product();
  new LocationList();
  new JobCarousel();
  let todayLateHours = document.getElementById(`late-hours-${Daypart.day}`);
  if (todayLateHours) {
    todayLateHours.classList.remove('LocationInfo-serviceHours--hide');
    todayLateHours.parentNode.parentNode.classList.remove('LocationInfo-serviceHours--hide');
  }

  const questions = document.querySelectorAll(".js-question");
  const answers = document.querySelectorAll(".js-answer");
  const arrows = document.querySelectorAll(".js-arrow");
  if (questions && answers){
    for(let i=0; i < questions.length && i < answers.length; i++){
      questions[i].addEventListener('click', function() {
        answers[i].classList.toggle('is-selected');
        arrows[i].classList.toggle('is-rotated');
      })
    }
  }

  CurrentlyOperatingServices.currentServices();

  // If there are no breakfast hours, we don't want to show a closed message at
  // all. Hide the hours status in this case.
  let breakfastInfo = document.querySelector('.js-breakfastInfo');
  if (breakfastInfo) {
    let today = breakfastInfo.querySelector('.js-is-today');
    if (today && today.querySelector('.js-hideBreakfastInfo')) {
      breakfastInfo.style = "display: none";
    }
  }

  // Add analytics for uk locations when cmp accept button is clicked
  const bodyEl = document.querySelector('body');
  if(bodyEl.dataset['isuklocation']) {
    const targetNode = document.querySelector('body');
    const config = { childList: true, subtree: true };
  
    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          const cmpEl = document.getElementById('onetrust-consent-sdk');
          console.log(cmpEl)
          const acceptBtn = document.getElementById('onetrust-accept-btn-handler');
          console.log(acceptBtn)
  
          // Add analytics to accept button and disconnect mutation observer if element exists
          if(cmpEl && acceptBtn) {
            acceptBtn.addEventListener('click', () => {
              window.enableYextAnalytics(true);
            })
            observer.disconnect();
          }
        }
      }
    };
  
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
  
    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  }
});
